<template>
	<div>
		<el-container v-if="items != null">
			<el-main v-if="items.length > 0">
				<el-card class="el-card-box" v-bind:key="item.index" v-for="item in items">
					<div slot="header" class="clearfix">
						<el-row>
							<el-col :span="18">
								<el-breadcrumb separator="/">
									<div class="xg-card-head">
										<el-breadcrumb-item>{{item.pname}}</el-breadcrumb-item>
										<el-breadcrumb-item>{{item.tname}}</el-breadcrumb-item>
									</div>
								</el-breadcrumb>
							</el-col>
							<el-col :span="6">
								<el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" />
								<el-button type="success" plain size="small"
									@click="onPreview(item.pname, item.tname, item.tid)">
									Pictures<i class="el-icon-picture-outline el-icon--right" />
								</el-button>
								<el-button type="success" plain size="small"
									@click="download(item.pname, item.tname, item.tid)">
									Download<i class="el-icon-download el-icon--right" />
								</el-button>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="24">
								<span class="xg-cor-name">common serum protein</span>
								<span class="xg-cor-icon">
									<i class="fa fa-check-square-o" v-if="item.common"></i><i class="fa fa-square-o" v-else="item.stomach"></i>
								</span>
								<span class="xg-cor-name">cancer-secreted protein</span>
								<span class="xg-cor-icon">
									<i class="fa fa-check-square-o" v-if="item.cancer"></i><i class="fa fa-square-o" v-else="item.breast"></i>
								</span>
							</el-col>
						</el-row>
					</div>

					<div class="xg-card-body">
						<div v-if="item.indicators">
							<el-table :data="item.indicators" stripe border style="width: 100%">
								<el-table-column prop="description" label="description" align="center"></el-table-column>
								<el-table-column prop="q1" label="Q1" width="120" align="center"></el-table-column>
								<el-table-column prop="q3" label="Q3" width="120" align="center"></el-table-column>
								<el-table-column prop="ce" label="CE" width="80" align="center"></el-table-column>
								<el-table-column prop="iRT" label="iRT" width="120" align="center"></el-table-column>
								<el-table-column prop="ionMobility" label="Ion Mobility" width="150" align="center"></el-table-column>
							</el-table>
						</div>
					</div>
				</el-card>
			</el-main>

			<el-main v-else class="box-error">
				<h5 class="text-center">There are no results for this condition.</h5>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import axios from "axios"
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

	export default {
		components: {
			'el-image-viewer': ElImageViewer
		},
		props: {
			items: {
				type: Array | null,
				required: false,
				default: null
			}
		},
		data() {
			return {
				showViewer: false,
				url: null,
				srcList: null
			}
		},
		methods: {
			download(pname, tname, tid) {
				axios
					.get("/otherDownload.do", {
						responseType: 'blob',
						params: {
							pname: pname,
							tname: tname,
							tid: tid
						}
					})
					.then(response => {
						var link = document.createElement("a")
						link.href = window.URL.createObjectURL(new Blob([response.data]))
						link.setAttribute("download", tname + ".zip")
						document.body.appendChild(link)
						link.click()
						document.body.removeChild(link)
					})
					.catch(err => {
						console.log(err)
					})
			},
			onPreview(pname, tname, tid) {
				axios
					.post("/getOtherPics.do", null, {
						params: {
							peptideId: tid
						}
					})
					.then(response => {
						var pDir = "/static/other/pics/" + pname + "/" + tname + "/"
						var urls = []

						var peptide = response.data	//peptide = { "p1": 1, "p2": 1, "p3": 0, "p4": 1 }
						if (peptide.p1) urls.push(pDir + "1.png")
						if (peptide.p2) urls.push(pDir + "2.png")
						if (peptide.p3) urls.push(pDir + "3.png")
						if (peptide.p4) urls.push(pDir + "4.png")

						this.url = urls[0]
						this.srcList = urls
						this.showViewer = true
					})
					.catch(err => {
						console.log(err)
					})
			},
			closeViewer() {
				this.showViewer = false
			}
		}
	}
</script>

<style>
	.el-card-box {
		margin: 36px auto;
	}
	.xg-card-head {
		font-weight: 400;
		margin: auto 10px;
	}
	.el-image__inner {
		margin: 20px auto;
	}
</style>